<template>
    
    <photo-book-cover-preview :token="currentPhotoBook.id"></photo-book-cover-preview>

</template>
    <script>
    import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
        import PhotoBookCoverPreview from '@/views/Pages/PhotoBookCoverPreview'

      import { Tooltip } from 'element-ui'
       import draggable from 'vuedraggable'
      export default {
        name: 's06',
        components: {
          [Tooltip.name]: Tooltip,
          draggable,
          PhotoBookCoverPreview,
        },
        data() {
          return {
            myArray: [
                { name: "test1"},
                { name: "test2"},
                { name: "test3"},
                { name: "test4"},
                { name: "test5"},

          ],
            activeNames: '',
            drag: false,
            isDragging: false,
            loading: false,
          }
        },
        methods: {
            allDataValidated: function () {
                
                this.$emit('allowProceed');
            },
            buildUrl(image){
                let ht = this.$image_host+image.image.medium.url;
                return ht
            },
            checkMove: function(evt){
                console.log(evt);
//                return (evt.draggedContext.element.name!=='apple');
            },
            onMove({ relatedContext, draggedContext }) {
                console.log("onMOVE");
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    handleChange(lo) {
     this.loading = true;
      console.log('changed');

            this.$store.dispatch('repositionPhotoBookImage',  { pbid: this.currentPhotoBook.id, pbiid: lo.originalEvent.target.id, pos: lo.newIndex+1 }).then((response) => {
                console.log(response);
            })
            .catch((error) => {
                console.error(error);
                this.loading = true;
            }).finally(() => {
                    this.loading = false;
                });
                /*
      this.$store.dispatch('repositionPhotoBookImage', { pbid: this.currentPhotoBook.id, pbiid: lo.originalEvent.target.id, pos: lo.newIndex+1 })
      .then((response) => {
          console.log(response);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
*/

     // this.$store.dispatch('repositionPhotoBookImage', { pbid: this.currentPhotoBook.id, pbiid: lo.originalEvent.target.id, pos: lo.newIndex });
     // this.loading = false;
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    },
        },
        computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
            currentPhotoBookImages: 'currentPhotoBookImages',
        }),
        },
        mounted(){
            this.$emit('denyProceed');
            this.allDataValidated();
            this.$store.dispatch('fetchPhotoBookImages', { pbid: this.currentPhotoBook.id, imagetype: "interiorreq" });

//            repositionPhotoBookImage
            console.log(this.currentPhotoBookImages);
        },
      };
    </script>
    <style scoped>
    
    
    .card{
        position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      min-width: 0;
      word-wrap: break-word;
      background-color: #fff;
      background-clip: border-box;
      border: 1px solid rgba(0,0,0,.05);
      border-radius: .375rem;
      margin-bottom: 30px;
      -webkit-box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
      box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
      border: 0;
    }
    body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
        background-color: #f8f9fe;
    }
    .grid-item,.grid-item .action-container, .grid-item .overlay{
        transition: all 1s;
    }
    
    .grid-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 15px;
        padding: 10px;
    }
    .card .grid-container{
        background: transparent;
        margin: 1rem 1.5rem;
    }
    @media (min-width: 992px) {
        .grid-container {
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 25px;
        }
    }
    @media (min-width: 1200px) {
        .grid-container {
            grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
            gap: 30px;
        }
    }
    @media (min-width: 1500px) {
        .grid-container {
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 50px;
        }
    }
    .grid-item {
        background-color: #ffffff;
        border: 1px solid #ddd;
        box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
        overflow: hidden;
        position: relative;
        padding-top: 100%; 
        border-radius: .375rem;
        border: 1px solid var(--lr-item-border-color);
        margin-top: 5px;
        margin-bottom: 0;
    }
    
    .grid-item:hover{
        border: 1px solid #f2f4ff;
        box-shadow: 0 0 1rem 0 rgba(136,152,170,.35);
        background-color: #f2f4ff;
        margin-top: 0;
        margin-bottom: 5px;
    }
    .grid-item.is-checked {
        border: 1px solid #f2f4ff;
        background-color: #f2f4ff;
    }
    
    .grid-item img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center; 
    }
    
    .overlay {
        display: none;
    }
    .grid-item .img-name{
        opacity: 1;
        position: absolute;
        z-index: 10;
        bottom: 0;
        right: 0; 
        width: auto;
        background-color: rgba(23,43,77,.8);
        color: #FFFFFF;
        text-align: center;
        padding: .15em .6em;
        box-sizing: border-box;
        font-size: 0.75rem;
        display: block;
        border-radius:  .375rem 0 0 0;
        box-shadow: 0 0 .3rem 0 rgba(136,152,170,.75);
    }
    .grid-item:hover .img-name {
            opacity: 1;
    }
    .grid-item .number{
        position: absolute;
        z-index: 11;
        top: 0em;
        padding: .15em .6em;
        left: 0em;
        width: auto;
        display: inline-block;
        background-color: rgba(23,43,77,.8);
        color: #FFFFFF;
        text-align: left;
        border-radius: 0 0 .375rem 0;
        font-size: 0.75em;
        letter-spacing: 0.02em;
    }
    
    .grid-item .action-container {
        opacity: 0;
        position: absolute;
        z-index: 11;
        top: 0;
        right:0;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        display: block;
    }
    .grid-item:hover .action-container {
        opacity: 1;
    }
    .grid-item .action-container .do-uncheck{
        display: none;
    }
    .grid-item .action-container .do-check{
        display: inline-block;
    }
    .grid-item.is-checked .action-container .do-uncheck{
        display: inline-block;
    }
    .grid-item.is-checked .action-container .do-check{
        display: none;
    }

    </style>